import { Api } from "../utils/Api";

async function fetch(token) {
  try {
    return await Api.get("authServiceUrl", `actions`, token);
  } catch (e) {
    throw e;
  }
}

async function fetchAll(token) {
  try {
    return await Api.get("authServiceUrl", `actions/list`, token);
  } catch (e) {
    throw e;
  }
}

async function update(token, data) {
  try {
    return await Api.post("authServiceUrl", `actions/list`, token, data);
  } catch (e) {
    throw e;
  }
}

export const actionsPermissionsService = {
  fetch,
  fetchAll,
  update,
};
